import React, { createContext, useEffect, useState } from 'react';
import {
  getSessionVal,
  rmApplicationStr,
  setSessionStorage,
} from 'utils/CommonFunc';
import { checkNullUndefined } from 'utils/checkNullUndefined';

export const AuthContext = createContext();

const AuthContextProvider = props => {
  const [isLoggedIn, setIsLoggedIn] = useState(
    checkNullUndefined(getSessionVal('authToken')) || !!props.authToken
  );
  const [authToken, setAuthToken] = useState(
    checkNullUndefined(getSessionVal('authToken'))
      ? getSessionVal('authToken')
      : null
  );
  const [jwtToken, setJWToken] = useState(
    checkNullUndefined(getSessionVal('jwtToken'))
      ? getSessionVal('jwtToken')
      : props.jwtToken || null
  );
  const [userInfo, setUserInfo] = useState(
    checkNullUndefined(getSessionVal('user')) ? getSessionVal('user') : null
  );
  const [parentUrl, setParentUrl] = useState('');
  // check iframe
  const [isDirect, setIsDirect] = useState(window === window.parent);

  const changeAuthStatus = param => {
    setIsLoggedIn(param);
  };

  const logout = () => {
    rmApplicationStr();
    setIsLoggedIn(false);
    setJWToken(null);
    setAuthToken(null);
    setUserInfo(null);
    setParentUrl('');
    setIsDirect(false);
  };

  useEffect(() => setAuthToken(props.authToken), [props.authToken]);

  return (
    <AuthContext.Provider
      value={{
        isLoggedIn,
        authToken,
        jwtToken,
        parentUrl,
        userInfo,
        isDirect,
        setIsDirect,
        logout,
        changeAuthStatus,
        setJWToken: jwt => {
          setSessionStorage('jwtToken', jwt);
          setJWToken(jwt);
        },
        setAuthToken: authToken => {
          setSessionStorage('authToken', authToken);
          setAuthToken(authToken);
        },
        setUserInfo: user => {
          setUserInfo(user);
          setSessionStorage('user', JSON.stringify(user));
        },
        setParentUrl: url => {
          url =
            url.charAt(url.length - 1) === '/'
              ? url.split('/').slice(0, -1).join('/')
              : url;
          setParentUrl(url);
          setSessionStorage('ParentURL', url);
        },
      }}>
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthContextProvider;
